import React, { useState } from "react";
import fiat from "./images/fiat.jpg";
import crypto from "./images/crypto.png";
import "flowbite";
import Fiat from "./Fiat";
import { AiFillDollarCircle } from "react-icons/ai";
import Registration from "./Registration";
import StripePaymentForm from "./Fiat";

const Paymentmethod = (props) => {
  const [showFiatModal, setShowFiatModal] = useState(false);
  const [showCryptoModal, setShowCryptoModal] = useState(false);

  const openFiatModal = () => {
    showFiatModal ? setShowFiatModal(false) : setShowFiatModal(true);
  };

  const openCryptoModal = () => {
    showCryptoModal ? setShowCryptoModal(false) : setShowCryptoModal(true);
  };

  return (
    <>
      <div
        className="relative z-50"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div className="fixed inset-0 bg-black bg-opacity-20 backdrop-blur transition-opacity"></div>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-2 text-center sm:items-center sm:p-0">
            <div className="relative bg-gradient-to-bl from-[#212445] via-[#212445] to-[#462E52] rounded-lg shadow dark:bg-gray-700 py-2">
              <div className="bg-gradient-to-bl from-[#212445] via-[#212445] to-[#462E52] p-2">
                <div className="sm:flex sm:items-start">
                  <div className="m-2 text-center sm:text-left">
                    <h1 className="text-xl font bold text-white">
                      Before you register, which Payment Method do you prefer?{" "}
                    </h1>
                    <div className="mt-2">
                      <div
                        onClick={() => openFiatModal()}
                        className="flex gap-4 hover:cursor-pointer"
                        // data-modal-target="fiat-modal"
                        // data-modal-toggle="fiat-modal"
                        // data-modal-hide="payment-modal"
                      >
                        <h1 className="text-4xl my-auto bold text-left text-white">
                          <AiFillDollarCircle />
                        </h1>
                        <h1 className="text-lg font my-auto bold text-left text-white">
                          Credit Card (MasterCard, Amex, Visa)
                        </h1>
                      </div>
                      <div
                        onClick={() => openCryptoModal()}
                        className="flex gap-4 mt-2 hover:cursor-pointer"
                        // data-modal-target="authentication-modal"
                        // data-modal-toggle="authentication-modal"
                        // data-modal-hide="payment-modal"
                      >
                        <img src={crypto} className="rounded-full h-8" />
                        <h1 className="text-lg font my-auto bold text-left text-white">
                          Crypto
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <button
                onClick={() => props.modalClose()}
                type="button"
                className="mx-4 my-2 w-[90%] text-center rounded-lg bg-white px-5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 "
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      {showCryptoModal ? (
        <Registration
          modalCryptoClose={() => {
            openCryptoModal();
            props.modalClose();
          }}
        />
      ) : (
        ""
      )}
      {showFiatModal ? (
        <StripePaymentForm
          modalFiatClose={() => {
            openFiatModal();
            props.modalClose();
          }}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default Paymentmethod;
